'use client';
import { ComponentType } from 'react';
import { HeightSinceWidth } from '../placeholder/placeholder.component';
import { PlaceholderConfig } from '@spa/lib/react/context/PlaceholderContext';
import { Props } from './product-specifications.component';
import dynamic from 'next/dynamic';

const DynamicProductSpecificationsComponent: ComponentType<Props> = dynamic(
  () => import('./product-specifications.component')
);

export default DynamicProductSpecificationsComponent;

export function calculateProductSpecificationsPlaceholderConfig(props: Props): PlaceholderConfig {
  const specificationDescription: string | null = props.descriptionHtml;
  const specificationDescriptionLength: number | undefined = specificationDescription?.length;

  let heightSinceWidth: HeightSinceWidth;
  if (specificationDescriptionLength && specificationDescriptionLength !== 0) {
    heightSinceWidth = [
      { sinceWidth: 0, height: 134 },
      { sinceWidth: 768, height: 151 },
      { sinceWidth: 1024, height: specificationDescriptionLength / 117 + 30 + 25 },
      { sinceWidth: 1440, height: specificationDescriptionLength / 164 + 30 + 25 }
      // specificationDescriptionLength is divided by the number of characters that fit in a line
      // then the height of the specifications tabs and the margin-top of the description title
      // are added, in that order.
    ];
  } else {
    heightSinceWidth = [
      { sinceWidth: 0, height: 134 },
      { sinceWidth: 768, height: 151 },
      { sinceWidth: 1024, height: 87 }
    ];
  }

  return {
    heightSinceWidth
  };
}
